import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;

export const Form = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Row = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;

  > * {
    width: 50%;
  }

  @media (max-width: ${theme.breakpoints.values.sm}px) {
    flex-direction: column;

    > * {
      width: 100%;
    }
  }
`;

export const Actions = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;

  > div {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;
